<template>
  <div>
    <div class="signup-page">
      <div v-if="infoText != ''" class="info alert alert-success">
        <p>{{infoText}}</p>
      </div>
      <div v-if="errors.length>0">
        <ul id="errors" class="alert alert-danger">
          <li v-for="(error,index) in errors" :key="index">{{error[0]}}</li>
        </ul>
      </div>

      <p v-if="this.$i18n.locale == 'pl'" style="font-size: 11px;width: 100%;margin: 0px auto;">Przed wypełnieniem formularza rejestracyjnego, w którym Pan / Pani
        podaje Swoje dane osobowe, a które będą przetwarzane przez PULSAR K. Bogusz Sp.j.,
        prosimy Pana / Panią o zapoznanie się z informacjami zapisanymi w
        <a href='https://www.pulsar.pl/PL_9985_ochrona-danych-osobowych' class='linki' target='_new'>"Ochrona danych osobowych"</a>, <a href='https://www.pulsar.pl/PL_10004_polityka-prywatnosci-w-pulsar' class='linki' target='_new'>"Polityka prywatności"</a>, w celu uzyskania pełnych informacji,
        kto jest Administratorem Pana / Pani danych osobowych, pozyskanych poprzez wypełnienie formularza kontaktowego, o Pana / Pani
        prawach związanych z przetwarzaniem danych osobowych oraz celach i podstawach prawnych ich przetwarzania.</p>

      <h1 v-if="this.$i18n.locale == 'pl'"
        style="font-size: 16px;margin: 0px auto;padding: 10px;color: rgb(0, 86, 179);width: 650px;"
      >{{ $t("message.regi_form") }}</h1>

      <h1 v-else
        style="font-size: 16px;margin: 0px auto;padding: 10px;color: rgb(0, 86, 179);width: 360px;"
      >{{ $t("message.regi_form") }}</h1>
      <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx PL xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
      <div class="formPL row" v-if="this.$i18n.locale == 'pl'">
        <template>
          <div class="imgPulsar">
            <img src="../../assets/logo.png" style="width: 225px;margin: 0px 0px 20px 0px; float:none">
          </div>

          <div class='col-12 col-sm-12	col-md-6 col-lg-6 col-xl-6'>
            <h6 style="text-align:left">Osoba reprezentująca</h6>
            <transition name="fade">
            <label class="labels"
              v-if="user.name">
              {{$t('message.name')}}</label></transition>
            <input v-model="user.name" type="text" name="name" :placeholder="$t('message.name')+' *'">

            <transition name="fade">
            <label class="labels"
              v-if="user.surname">
              {{$t('message.surname')}}</label></transition>
            <input
              v-model="user.surname"
              type="text"
              name="surname"
              :placeholder="$t('message.surname')+' *'"
            >

            <transition name="fade">
            <label class="labels"
              v-if="user.position">
              {{$t('message.position')}}</label></transition>
            <input
              v-model="user.position"
              type="text"
              name="position"
              :placeholder="$t('message.position')+' *'"
            >

            <transition name="fade">
            <label class="labels"
              v-if="user.phone">
              {{$t('message.phone')}}</label></transition>
            <input v-model="user.phone" type="text" name="phone" :placeholder="$t('message.phone')+' *'">

            <transition name="fade">
            <label class="labels"
              v-if="user.email">
              {{$t('message.email')}}</label></transition>
            <input v-model="user.email" type="text" name="email" :placeholder="$t('message.email')+' *'">

            <transition name="fade">
            <label class="labels"
              v-if="user.password">
              {{$t('message.pass')}}</label></transition>
            <input
              v-model="user.password"
              type="password"
              name="password"
              :placeholder="$t('message.pass')+' *'"
            >

            <transition name="fade">
            <label class="labels"
              v-if="user.confirm_password">
              {{$t('message.pass_repeat')}}</label></transition>
            <input
              v-model="user.confirm_password"
              type="password"
              name="confirm_password"
              :placeholder="$t('message.pass_repeat')+' *'"
            >
          </div>

          <div class='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
            <h6 style="text-align:left">Dane firmy</h6>
            <transition name="fade">
            <label class="labels"
              v-if="user.company">
              {{$t('message.company')}}</label></transition>
            <input
              v-model="user.company"
              type="text"
              name="company"
              :placeholder="$t('message.company')+' *'"
            >

            <transition name="fade">
            <label class="labels"
              v-if="user.nip">
              {{$t('message.nip')}}</label></transition>
            <input v-model="user.nip" type="text" name="nip" :placeholder="$t('message.nip')+' *'">

            <transition name="fade">
            <label class="labels"
              v-if="user.street">
              {{$t('message.street')}}</label></transition>
            <input v-model="user.street" type="text" name="street" :placeholder="$t('message.street')+' *'">

            <transition name="fade">
            <label class="labels"
              v-if="user.city">
              {{$t('message.city')}}</label></transition>
            <input
              v-model="user.city"
              type="text"
              name="city"
              :placeholder="$t('message.city')+' *'"
            >
            <transition name="fade">
            <label class="labels"
              v-if="user.zip">
              {{$t('message.zip')}}</label></transition>
            <input v-model="user.zip" type="text" name="zip" :placeholder="$t('message.zip')+' *'">
          </div>

          <p class='col-sm-12'>* - {{$t('message.required')}}</p>
          <!-- SERWER -->

          <button v-if="disabled_pl == false" @click="executeRecaptcha" style="width:100%; height:35px">
              <div v-if="spinner" class="spinnerek"></div><span v-if="!spinner">{{$t('message.register')}}</span></button>
          <recaptcha ref="recaptcha" @verify="save"></recaptcha>
          <div v-if="disabled_pl == true" class="btnDisabled" style="width:100%; height:35px">{{$t('message.register')}}</div>

          <!-- LOCALHOST TESTOWANIE -->
          <!--
          <div v-if="disabled_pl == true" class="btnDisabled">{{$t('message.register')}}</div>
          <button v-if="disabled_pl == false" @click="save">{{$t('message.register')}}</button>
          -->

          <div class="message">
            <router-link to="/login" class="btn btn-link">{{$t('message.anuluj')}}</router-link>
          </div>
        </template>
      </div>

      <div class="formEN" v-else>

        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx EN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
        <template>
          <div class="imgPulsar">
            <img src="../../assets/logo.png" style="width: 225px;margin: 0px 0px 20px 0px; float:none">
          </div>

          <transition name="fade">
          <label class="labels"
            v-if="user.name">
            {{$t('message.name')}}</label></transition>
          <input v-model="user.name" type="text" name="name" :placeholder="$t('message.name')">

          <transition name="fade">
          <label class="labels"
            v-if="user.surname">
            {{$t('message.surname')}}</label></transition>
          <input
            v-model="user.surname"
            type="text"
            name="surname"
            :placeholder="$t('message.surname')"
          >

          <transition name="fade">
          <label class="labels"
            v-if="user.company">
            {{$t('message.company')}}</label></transition>
          <input
            v-model="user.company"
            type="text"
            name="company"
            :placeholder="$t('message.company')"
          >
          <select v-model="user.country" name="country">
            <option value selected="selected">{{$t('message.country')}}</option>
            <option v-for="country in countryList" :key="country.name">{{ country.name }}</option>
          </select>

          <transition name="fade">
          <label class="labels"
            v-if="user.phone">
            {{$t('message.phone')}}</label></transition>
          <input v-model="user.phone" type="text" name="phone" :placeholder="$t('message.phone')">

          <transition name="fade">
          <label class="labels"
            v-if="user.email">
            {{$t('message.email')}}</label></transition>
          <input v-model="user.email" type="text" name="email" :placeholder="$t('message.email')">

          <transition name="fade">
          <label class="labels"
            v-if="user.password">
            {{$t('message.pass')}}</label></transition>
          <input
            v-model="user.password"
            type="password"
            name="password"
            :placeholder="$t('message.pass')"
          >

          <transition name="fade">
          <label class="labels"
            v-if="user.confirm_password">
            {{$t('message.pass_repeat')}}</label></transition>
          <input
            v-model="user.confirm_password"
            type="password"
            name="confirm_password"
            :placeholder="$t('message.pass_repeat')"
          >
          <p>* - {{$t('message.required')}}</p>

          <!-- SERWER -->

          <button v-if="disabled_en == false" @click="executeRecaptcha" style="width:100%; height:35px">
            <div v-if="spinner" class="spinnerek"></div><span v-if="!spinner">{{$t('message.register')}}</span></button>
          <recaptcha ref="recaptcha" @verify="save"></recaptcha>
          <div v-if="disabled_en == true" class="btnDisabled" style="width:100%; height:35px">{{$t('message.register')}}</div>

          <!-- LOCALHOST TESTOWANIE -->
          <!--
          <div v-if="disabled_en == true" class="btnDisabled">{{$t('message.register')}}</div>
          <button v-if="disabled_en == false" @click="save">{{$t('message.register')}}</button>
          -->

          <div class="message">
            <router-link to="/login" class="btn btn-link">{{$t('message.anuluj')}}</router-link>
          </div>
          <br>
        </template>
      </div>
      <!--</form>-->
    </div>

    <div style="max-width: 600px; margin: auto; margin-top: auto;">
      <input
        id="checkbox-1"
        v-model="rodo"
        @click="rodo = $event.target.value"
        name="checkbox-1"
        value="true"
        type="checkbox"
        unchecked-value="not_accepted"
      > &#8727;
      <span style="display: block;font-size: 12px;line-height: 14px;">{{$t('message.rodo')}}</span>
    </div>


    <!-- <div v-if="this.$i18n.locale == 'pl'" style="max-width: 600px; margin: auto; margin-top: auto; margin-top: 20px;">
      <input
        style="float: left;margin: 8px 10px 10px 0px;"
        id="checkbox-1"
        v-model="b2b"
        @click="selectB2B(!b2b)"
        name="checkbox-1"
        value="true"
        type="checkbox"
        unchecked-value="not_accepted"
      ><h4>Rejestracja Użytkownika B2B</h4>
      <table v-if="b2b" class="zgody">
        <tr></tr>
        <tr>
          <td>
            <input
              id="checkbox-1"
              v-model="b2b_all"
              @click="selectAll(!b2b_all)"
              name="checkbox-1"
              value="true"
              type="checkbox"
              unchecked-value="not_accepted"
            >
          </td>
          <td style="font-size:11px">Zaznaczam wszystkie poniższe zgody i je akceptuje.</td>
        </tr>
        <tr>
          <td>
            <input
              id="checkbox-1"
              v-model="b2b_regulamin"
              @click="b2b_regulamin = $event.target.value"
              name="checkbox-1"
              value="true"
              type="checkbox"
              unchecked-value="not_accepted"
            >
          </td>
          <td style="font-size:11px">Zapoznałem/am się i akceptuję <a href='https://www.pulsar.pl/pdf/b2b/Regulamin_platformy_B2B.pdf' class='linki' target="_new">Regulamin Platformy B2B *</a></td>
        </tr>
        <tr>
          <td>
            <input
              id="checkbox-1"
              v-model="b2b_warunki_umowy"
              @click="b2b_warunki_umowy = $event.target.value"
              name="checkbox-1"
              value="true"
              type="checkbox"
              unchecked-value="not_accepted"
            >
          </td>
          <td style="font-size:11px">Zapoznałem/am się i akceptuję <a href='https://www.pulsar.pl//pdf/umowa/ogolne_warunki_umowy.pdf' class='linki' target="_new">Ogólne Warunki Umowy</a> firmy PULSAR K. Bogusz Sp.j.*</td>
        </tr>
        <tr>
          <td>
            <input
              id="checkbox-1"
              v-model="b2b_przetw_danych"
              @click="b2b_przetw_danych = $event.target.value"
              name="checkbox-1"
              value="true"
              type="checkbox"
              unchecked-value="not_accepted"
            >
          </td>
          <td style="font-size:11px">Wyrażam zgodę na przetwarzanie Moich danych osobowych w postaci imienia, nazwiska, adresu e-mail w celu obsługi konta na platformie B2B firmy PULSAR K. Bogusz Sp.j. z wykorzystaniem poczty elektronicznej (zgodnie z ustawą z dnia 18 lipca 2002 r. o świadczeniu usług drogą elektroniczną – Dz. U. 2016.1030 z późn. zm.). oraz ustawą o ochronie danych osobowych.
            Masz prawo do wycofania udzielonej zgody w dowolnym momencie. Wycofanie zgody nie wpływa na legalność procesu przetwarzania, dokonanym przed jej wycofaniem. *</td>
        </tr>
        <tr>
          <td>
            <input
              id="checkbox-1"
              v-model="b2b_admin_danych"
              @click="b2b_admin_danych = $event.target.value"
              name="checkbox-1"
              value="true"
              type="checkbox"
              unchecked-value="not_accepted"
            >
          </td>
          <td style="font-size:11px">Oświadczam, że zapoznałem się z Informacją o Administratorze Danych
            oraz jestem świadomy/a swoich praw w związku z przetwarzaniem danych osobowych, podanych w niniejszym formularzu kontaktowym. *</td>
        </tr>
        <tr>
          <td>
            <input
              id="checkbox-1"
              v-model="b2b_marketing_email"
              @click="b2b_marketing_email = $event.target.value"
              name="checkbox-1"
              value="true"
              type="checkbox"
              unchecked-value="not_accepted"
            >
          </td>
          <td style="font-size:11px">Wyrażam zgodę na przetwarzanie Moich danych osobowych w postaci imienia, nazwiska, adresu e-mail dla potrzeb prowadzenia przyszłego marketingu bezpośredniego z wykorzystaniem poczty elektronicznej przez PULSAR K. Bogusz Sp.j. (zgodnie z ustawą z dnia 18 lipca 2002 r. o świadczeniu usług drogą elektroniczną – Dz. U. 2016.1030 z późn. zm.). oraz art. 12 Rozporządzenia Parlamentu Europejskiego i Rady (UE) nr 679/2016 z dnia 27 kwietnia 2016 r.
      Masz prawo do wycofania udzielonej zgody w dowolnym momencie. Wycofanie zgody nie wpływa na legalność procesu przetwarzania, dokonanym przed jej wycofaniem.</td>
        </tr>
        <tr>
          <td>
            <input
              id="checkbox-1"
              v-model="b2b_marketing_tel"
              @click="b2b_marketing_tel = $event.target.value"
              name="checkbox-1"
              value="true"
              type="checkbox"
              unchecked-value="not_accepted"
            >
          </td>
          <td style="font-size:11px">Wyrażam zgodę na przetwarzanie Moich danych osobowych w postaci imienia, nazwiska, nr telefonu kontaktowego dla potrzeb prowadzenia przyszłego marketingu bezpośredniego z wykorzystaniem połączeń telefonicznych przez PULSAR K. Bogusz Sp.j. (zgodnie z art. 12 Rozporządzenia Parlamentu Europejskiego i Rady (UE) nr 679/2016 z dnia 27 kwietnia 2016 r.).
            Masz prawo do wycofania udzielonej zgody w dowolnym momencie. Wycofanie zgody nie wpływa na legalność procesu przetwarzania, dokonanym przed jej wycofaniem.</td>
        </tr>
      </table>


      -->
      <!-- <span style="display: block;font-size: 12px;line-height: 14px;">{{$t('message.rodo')}}</span>-->
      <!--
        <span style="display: block;font-size: 12px;line-height: 14px;">

      </span>
    </div> -->

  </div>
</template>

<script>
// "

import router from "../../router";
import axios from "axios";
//import VueRecaptcha from "vue-recaptcha";

import Recaptcha from "./Recaptcha.vue";
import myJson from "../../assets/country.json";

export default {
  name: "SignUp",
  data() {
    return {
      user: {
        name: "",
        surname: "",
        position: "",
        email: "",
        phone: "",
        company: "",
        nip: "",
        street: "",
        city: "",
        zip: "",
        country: "",
        password: "",
        confirm_password: ""
      },
      infoText: "",
      loading: false,
      errored: false,
      visible: true,
      countryList: myJson,
      rodo: false,
      // b2b: false,
      // b2b_all: false,
      // b2b_regulamin: false,
      // b2b_warunki_umowy: false,
      // b2b_przetw_danych: false,
      // b2b_admin_danych: false,
      // b2b_marketing_email: false,
      // b2b_marketing_tel: false,
      spanName: false,
      spinner: false,
      errors: []
    };
  },
  components: { Recaptcha }, //VueRecaptcha },

  computed: {
    names() {
      return states.accounts.map(item => {
        return item.name;
      });
    },
    /*
    users() {
      return this.$store.getters["users/users"];
    },
    */
    disabled_pl() {
      return (
        !this.user.name ||
        !this.user.surname ||
        !this.user.position ||
        !this.user.email ||
        !this.user.phone ||
        !this.user.password ||
        !this.user.confirm_password ||
        !this.user.confirm_password == this.user.password ||

        !this.user.company ||
        !this.user.nip ||
        !this.user.street ||
        !this.user.city ||
        !this.user.zip ||
        !this.rodo
      );
    },
    disabled_en() {
      return (
        !this.user.name ||
        !this.user.surname ||
        !this.user.company ||
        !this.user.country ||
        !this.user.email ||
        !this.user.password ||
        !this.user.confirm_password ||
        !this.user.confirm_password == this.user.password ||
        !this.rodo
      );
    },
    allCompleted() {
      //return !this.visible;
    }
  },
  methods: {
    // send your recaptcha token to the server to verify it
    submit(response) {
      console.log(response);
    },
    // execute the recaptcha widget
    executeRecaptcha() {
      this.$refs.recaptcha.execute();
    },

    handleChildrenData(event) {
      console.log("zmienna od child", event);
      //this.visible = event;
    },

    // selectAll(event) {
    //   this.b2b_regulamin = event
    //   this.b2b_warunki_umowy = event
    //   this.b2b_przetw_danych = event
    //   this.b2b_admin_danych = event
    //   this.b2b_marketing_email = event
    //   this.b2b_marketing_tel = event
    // },
    // selectB2B (event) {
    //   this.b2b_all = false
    //   this.b2b_regulamin = false
    //   this.b2b_warunki_umowy = false
    //   this.b2b_przetw_danych = false
    //   this.b2b_admin_danych = false
    //   this.b2b_marketing_email = false
    //   this.b2b_marketing_tel = false
    // },

    save: function() {
      //e.preventDefault();
      const self = this;

      this.spinner = true;

      let lang = this.$i18n.locale;
      let trans = this.$i18n.messages[lang].message;

      //self.$router.push({ name: "LoginPage" });

      axios
        .post(process.env.VUE_APP_ROOT_API + "auth/signup", {
          //.post("https://app.pulsar.pl/api/auth/signup", {
          name: this.user.name,
          surname: this.user.surname,
          position: this.user.position,
          email: this.user.email,
          phone: this.user.phone,
          password: this.user.password,
          password_confirmation: this.user.confirm_password,

          company: this.user.company,
          nip: this.user.nip,
          street: this.user.street,
          city: this.user.city,
          zip: this.user.zip,
          country: this.user.country,
          lang: lang,

          // b2b_regulamin: this.b2b_regulamin,
          // b2b_warunki_umowy: this.b2b_warunki_umowy,
          // b2b_przetw_danych: this.b2b_przetw_danych,
          // b2b_admin_danych: this.b2b_admin_danych,
          // b2b_marketing_email: this.b2b_marketing_email,
          // b2b_marketing_tel: this.b2b_marketing_tel

        })
        .then(function(response) {
          // console.log(response.data);
          // console.log(response.request);

          if (response.data.token) {
            console.log("Rejestracja zakończona pomyślnie.");
            self.spinner = false;
            self.errors = [];
            self.infoText = trans["infoText"];
            //window.location.replace("/test_login/");
            self.$router.push({ name: "LoginPage" });
          } else if (response.data.status == false) {
            console.log("błędne dane");
            alert("Login incorrect");
          } else {
            console.log("validacja");
            self.spinner = false;
            /*
            let errors = "";
            for (let err of Object.values(response.data)) {
              errors += err + "\n"; //err trans[err]
            }
            alert(errors);
            */
            self.errors = [];
            for (let err of Object.values(response.data)) {
              //self.errors.push += err + " ";
              self.errors.push(err);
            }
            self.spinner = false;
            //alert(self.errors);
            //console.log(self.errors);
          }
        })
        .catch(function(error) {
          console.log(error);
          alert("Problem z połączeniem.");
        });
    }
  },
  mounted() {
    /*
    axios
      .get("http://127.0.0.1:8081/api/users")
      .then(response => {
        this.info = response.data;
      })
      .catch(error => {
        console.log(error);
        this.errored = true;
      })
      .finally(() => (this.loading = false));
      */
  },
  created() {
    /*
    try {
      //this.$store.dispatch("app/reset");
      this.$store.dispatch("users/load_users").then(response => {
        this.db_users = response;
        this.loading = false;
      });
    } catch (err) {
      console.error(err);
    }
  */
  }
};
</script>

<style scoped>
h4 {
    font-size: 1.2rem;
}
.txtsmall {
  font-size: 14px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.labels{
font-size: 10px;
display: table-row;
position: absolute;
right: 35px;
line-height: 35px;
color: #bbb;
}
.linki {
  color: red  !important;
  text-decoration: none !important;
}
/*
#login {
  width: 500px;
  margin: 0 auto;
  padding: 23px;
  background: #ddd;
  border-radius: 10px;
  box-shadow: 5px 5px;
}
*/
@import url(https://fonts.googleapis.com/css?family=Roboto:300);



.info {
  text-align: center;
  font-size: 18px;
  width: 100%;
  margin: 0px auto;
  max-width: 400px;
}

#errors {
  font-size: 14px;
  list-style: disclosure-closed;
  list-style-position: outside;
  list-style-position: outside;
  margin: 0px auto;
  padding: 10px;
  list-style-position: inside;
  width: 360px;
}
#errors li {
  padding: 0px;
}

.btnDisabled {
  font-family: "Roboto", sans-serif;
  text-transform: uppercase;
  outline: 0;
  background: #23497f;
  width: 100%;
  border: 0;
  padding: 8px;
  color: #ffffff;
  font-size: 14px;
  -webkit-transition: all 0.3 ease;
  transition: all 0.3 ease;
  cursor: no-drop;
}

.login-page {
  width: 360px;
  padding: 0px;
  margin: auto;
}

.formEN, .formPL {
  position: relative;
  z-index: 1;
  background: #ffffff;
  max-width: 360px;
  margin: 0 auto 2px;
  padding: 20px;
  text-align: center;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);
}
.formPL {
  max-width: 650px;
}
div.formEN p, div.formPL p {
  font-size: 14px;
  text-align: left;
  color: #999;
}
.formEN div, .formPL div{
  width: 50%;
}
.formEN input, .formPL input {
  font-family: "Roboto", rgba(95, 95, 95, 0.2);
  outline: 0;
  background: #f2f2f2;
  width: 100%;
  border: 0;
  margin: 0 0 0px;
  padding: 4px;
  box-sizing: border-box;
  font-size: 14px;
}
.formEN button, .formPL button {
  font-family: "Roboto", sans-serif;
  text-transform: uppercase;
  outline: 0;
  background: #23497f;
  width: 100%;
  border: 0;
  padding: 8px;
  color: #ffffff;
  font-size: 14px;
  -webkit-transition: all 0.3 ease;
  transition: all 0.3 ease;
  cursor: pointer;
}
.formEN select, .formPL select {
  font-family: "Roboto", sans-serif;
  outline: 0;
  background: #f2f2f2;
  width: 100%;
  border: 0;
  margin: 3px 0 0px;
  padding: 8px;
  box-sizing: border-box;
  font-size: 14px;
}
.formEN button:hover,
.formEN button:active,
.formEN button:focus,
.formPL button:hover,
.formPL button:active,
.formPL button:focus {
  background: #0056b3;
}
.formEN .message, .formPL .message {
margin: 8px 0px 0px;
color: #b3b3b3;
width: 100%;
}
.formEN .message a, .formPL .message a {
color: #595959;
text-decoration: none;
float: left;
font-size: 14px;
background: #c0c0c0;
border-radius: 0px;
width: 100%;
height: 25px;
line-height: 14px;
}
.formEN .message a:hover, .formPL .message a:hover {
  color: #0056b3;
}
.formEN .register-form, .formPL .register-form {
  display: none;
}

.zgody tr {
  vertical-align: baseline !important;
  line-height: 12px;
}
.zgody tr td{
padding-left: 5px;
}
.zgody tr td input{
position: relative;
top: 4px;
}
.container {
  position: relative;
  z-index: 1;
  max-width: 300px;
  margin: 0 auto;
}
.container:before,
.container:after {
  content: "";
  display: block;
  clear: both;
}
.container .info {
  margin: 50px auto;
  text-align: center;
}
.container .info h1 {
  margin: 0 0 15px;
  padding: 0;
  font-size: 36px;
  font-weight: 300;
  color: #1a1a1a;
}
.container .info span {
  color: #4d4d4d;
  font-size: 12px;
}
.container .info span a {
  color: #000000;
  text-decoration: none;
}
.container .info span .fa {
  color: #ef3b3a;
}
.imgPulsar{
  width: 100% !important
}


.spinnerek {
color: #ffffff;
font-size: 4px;
margin: 0px auto;
width: 1em !important;
height: 1em;
border-radius: 50%;
position: relative;
text-indent: -9999em;
  -webkit-animation: load4 1.3s infinite linear;
  animation: load4 1.3s infinite linear;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
@-webkit-keyframes load4 {
  0%,
  100% {
    box-shadow: 0 -3em 0 0.2em, 2em -2em 0 0em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 0;
  }
  12.5% {
    box-shadow: 0 -3em 0 0, 2em -2em 0 0.2em, 3em 0 0 0, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
  }
  25% {
    box-shadow: 0 -3em 0 -0.5em, 2em -2em 0 0, 3em 0 0 0.2em, 2em 2em 0 0, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
  }
  37.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 0, 2em 2em 0 0.2em, 0 3em 0 0em, -2em 2em 0 -1em, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }
  50% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 0em, 0 3em 0 0.2em, -2em 2em 0 0, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }
  62.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 0, -2em 2em 0 0.2em, -3em 0 0 0, -2em -2em 0 -1em;
  }
  75% {
    box-shadow: 0em -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0.2em, -2em -2em 0 0;
  }
  87.5% {
    box-shadow: 0em -3em 0 0, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0, -2em -2em 0 0.2em;
  }
}
@keyframes load4 {
  0%,
  100% {
    box-shadow: 0 -3em 0 0.2em, 2em -2em 0 0em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 0;
  }
  12.5% {
    box-shadow: 0 -3em 0 0, 2em -2em 0 0.2em, 3em 0 0 0, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
  }
  25% {
    box-shadow: 0 -3em 0 -0.5em, 2em -2em 0 0, 3em 0 0 0.2em, 2em 2em 0 0, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
  }
  37.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 0, 2em 2em 0 0.2em, 0 3em 0 0em, -2em 2em 0 -1em, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }
  50% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 0em, 0 3em 0 0.2em, -2em 2em 0 0, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }
  62.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 0, -2em 2em 0 0.2em, -3em 0 0 0, -2em -2em 0 -1em;
  }
  75% {
    box-shadow: 0em -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0.2em, -2em -2em 0 0;
  }
  87.5% {
    box-shadow: 0em -3em 0 0, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0, -2em -2em 0 0.2em;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/Auth/Register.vue